import {commonWebSocket} from '@services/common/common.constants';
import {createReducer} from 'redux-act';
import {ITodo} from '@app-types/websocket/todo.types';

const defaultState = {
  todos: [],
};

const reducer = createReducer<typeof defaultState>({}, defaultState);

reducer
  .on(commonWebSocket.snapshot.TODO_SNAPSHOT, (state:any, payload:any) => {
    if (Array.isArray(payload?.todos))
    {
      return {
        ...state,
        todos: payload.todos.filter((todo: any) => todo && typeof todo === "object" && todo.id !== undefined),
      };
    } else {
      return state;
    }
  })
  .on(commonWebSocket.replace.TODO_UPDATE, (state:any, payload:any) => {
    if (payload?.todoUpdate && payload.todoUpdate.id !== undefined)
    {
      const newTodoList = Array.isArray(state.todos) ? state.todos.slice() : [];

        const todoToIndex = newTodoList.findIndex((todo: ITodo) => {
          return todo.id === payload.todoUpdate.id;
        });

        if (todoToIndex > -1)
        {
          newTodoList[todoToIndex] = payload.todoUpdate;
        } else {
          newTodoList.push(payload.todoUpdate);
        }

      return {
        ...state,
        todos:newTodoList
      };
    } else {
      return state;
    }
  })
  .on(commonWebSocket.special.TODO_REMOVED, (state:any, payload:any) => {
    if (payload.todoRemoved)
    {
      const newTodoList = Array.isArray(state.todos) ? state.todos.slice() : [];

      const todoToIndex = newTodoList.findIndex((todo: ITodo) => {
        return todo.id === payload.todoRemoved;
      });

      if (todoToIndex > -1)
      {
        newTodoList.splice(todoToIndex, 1);
      }
      return {
        ...state,
        todos:newTodoList
      };
    } else {
      return state;
    }
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/services/todos/todo.reducer.ts